import { blue, grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { breakdownGridRowIdKey } from "./data";

export const BREAKDOWN_GRID_ROW_HEIGHT = 52;
export const BREAKDOWN_GRID_HEADER_HEIGHT = 35;

export const getBreakdownGridHeight = (rowCount) =>
	Math.min(Math.max(rowCount * BREAKDOWN_GRID_ROW_HEIGHT + 40, 200), 520);

export const getBreakdownDataGridSx = (rowCount) => ({
	width: "100%",
	maxWidth: "100%",
	height: getBreakdownGridHeight(rowCount),
	background: "#fff",
	border: "none",
	overflowX: "hidden",
	"& .MuiDataGrid-main": { overflowX: "hidden" },
	"& .MuiDataGrid-virtualScroller": { overflowX: "hidden" },
	"& .MuiDataGrid-row": {
		cursor: "pointer",
		backgroundColor: "#fff",
		"&:nth-of-type(even)": { backgroundColor: grey[50] },
	},
	"& .MuiDataGrid-columnHeader": {
		cursor: "pointer",
		backgroundColor: grey[100],
		borderBottom: `1px solid ${grey[300]}`,
	},
	"& .MuiDataGrid-cell": { padding: 0, borderBottom: `1px solid ${grey[200]}` },
	"& .MuiDataGrid-cell:focus-within": { outline: `1px solid ${blue[400]}`, outlineOffset: "-1px" },
	"& .MuiDataGrid-columnHeaders": {
		background: grey[100],
		borderBottom: `1px solid ${grey[300]}`,
		borderRadius: 0,
	},
	"& .MuiDataGrid-columnHeaderTitleContainer": { overflow: "hidden" },
	"& .MuiDataGrid-cellContent": { overflow: "hidden", textOverflow: "ellipsis" },
});

const BreakdownDataGrid = ({ rows = [], columns = [], ...rest }) => (
	<DataGrid
		columns={columns}
		rows={rows}
		getRowId={(row) => row?.[breakdownGridRowIdKey] ?? String(row?.id)}
		pagination={false}
		sx={getBreakdownDataGridSx(rows.length)}
		columnHeaderHeight={BREAKDOWN_GRID_HEADER_HEIGHT}
		rowHeight={BREAKDOWN_GRID_ROW_HEIGHT}
		showCellVerticalBorder
		disableRowSelectionOnClick
		{...rest}
	/>
);

export default BreakdownDataGrid;
